import { call, takeLatest } from "redux-saga/effects";
import * as companyApis from "../apis/companyApis"
import { COMPANY_REGISTER } from "../actions/types";

export function* companyRegisterWorker(action) {
    try {
        const res = yield call(companyApis.companyRegisterApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* companyRegisterWatcher() {
    yield takeLatest(COMPANY_REGISTER, companyRegisterWorker);
}